module.exports = __webpack_public_path__ + "media/images/solution_public-d213a5fa10ab27062a706c8c3e5a28d8.svg";